import { useSearchParams, Link } from 'react-router';
import { Container, Typography, Paper, Button, Box } from '@mui/material';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { useTranslation } from 'react-i18next';

export const MainErrorFallback = () => {
  const [searchParams] = useSearchParams();
  const { t } = useTranslation();
  const errorMessage = searchParams.get('error') || t('common.errors.unknownError');

  return (
    <Container maxWidth='md' sx={{ py: 8 }}>
      <Paper
        elevation={3}
        sx={{
          p: 4,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          textAlign: 'center',
        }}
      >
        <ErrorOutlineIcon color='error' sx={{ fontSize: 64, mb: 2 }} />

        <Typography variant='h4' component='h1' gutterBottom>
          {t('common.errors.errorTitle')}
        </Typography>

        <Typography variant='body1' color='text.secondary' sx={{ mb: 4 }}>
          {errorMessage}
        </Typography>

        <Box>
          <Button variant='contained' component={Link} to='/' sx={{ mr: 2 }}>
            {t('common.buttons.goHome')}
          </Button>

          <Button variant='outlined' onClick={() => window.location.reload()}>
            {t('common.errors.tryAgain')}
          </Button>
        </Box>
      </Paper>
    </Container>
  );
};

export default MainErrorFallback;
